import { atom } from "recoil";

export const AtomScore = atom({
  key: "AtomScoreKey",
  default: {
    height: 0,
    job: 0,
    degree: 0,
    family: 0,
    economy: 0,
  },
});
